import constate from 'constate';

import { IAuthUser } from 'auth/types';
import { useCorporateUserActions } from 'corporate/hooks';

const useSwitchUserVersion = () => {
  const { changeUserVersion } = useCorporateUserActions();

  const onUserVersionChange = async (user: IAuthUser | null) => {
    if (!user) {
      return;
    }

    await changeUserVersion({
      alternateVersionEnabled: user.alternateVersionEnabled ? 0 : 1,
    });
  };

  return {
    onUserVersionChange,
  };
};

export const [SwitchUserVersionProvider, useSwitchUserVersionContext] =
  constate(useSwitchUserVersion);
